import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './invozio-app-tour.component.scss';
import { useOnboardingStatus } from '../hooks/useOnboardingStatus';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../hooks/useRedux';
import { updateUserOnboardingService } from '../features/userOnboarding/userOnboarding.slice';
import { getUserOnboarding } from '../../redux/auth/authSlice';

// SVG icons (you may need to update these paths based on your project structure)
const starIcon =
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            d="M5.63014 0.897322C5.69371 0.586309 6.13809 0.586309 6.20166 0.897322L6.69618 3.3168C6.88338 4.23267 7.59912 4.94842 8.51499 5.13562L10.9345 5.63014C11.2455 5.69371 11.2455 6.13809 10.9345 6.20166L8.51499 6.69618C7.59912 6.88338 6.88338 7.59912 6.69618 8.51499L6.20166 10.9345C6.13809 11.2455 5.69371 11.2455 5.63014 10.9345L5.13562 8.51499C4.94842 7.59912 4.23267 6.88338 3.3168 6.69618L0.897322 6.20166C0.586309 6.13809 0.586309 5.69371 0.897322 5.63014L3.3168 5.13562C4.23267 4.94842 4.94842 4.23267 5.13562 3.3168L5.63014 0.897322Z"
            stroke="#F9F9F9"
            strokeWidth="1.33"
        />
    </svg>
    ;
const closeIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M18 6L6 18M18 18L6 6.00001"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
    />
</svg>
    ;
const playIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
>
    <path
        d="M5.83398 14.9497V5.05255C5.83398 3.66976 7.4208 2.88841 8.51684 3.73151L14.95 8.68007C15.8173 9.34723 15.8173 10.655 14.95 11.3221L8.51684 16.2707C7.4208 17.1138 5.83398 16.3325 5.83398 14.9497Z"
        stroke="#3C2E6A"
        strokeWidth={2}
        strokeLinecap="round"
    />
</svg>
    ;
const downloadIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
>
    <path
        d="M9.17094 0.835937C9.17094 0.37478 8.79709 0.000937462 8.33594 0.000937521C7.87478 0.000937581 7.50094 0.37478 7.50094 0.835938L8.33594 0.835938L9.17094 0.835937ZM7.50094 10.0026C7.50094 10.4638 7.87478 10.8376 8.33594 10.8376C8.7971 10.8376 9.17094 10.4638 9.17094 10.0026H8.33594L7.50094 10.0026ZM12.2597 8.92637C12.5858 8.60028 12.5858 8.07159 12.2597 7.7455C11.9336 7.41942 11.4049 7.41942 11.0788 7.7455L11.6693 8.33594L12.2597 8.92637ZM8.92519 11.08L8.33476 10.4896V10.4896L8.92519 11.08ZM7.74668 11.08L8.33712 10.4896H8.33712L7.74668 11.08ZM5.59304 7.7455C5.26695 7.41942 4.73826 7.41942 4.41217 7.7455C4.08608 8.07159 4.08608 8.60028 4.41217 8.92637L5.0026 8.33594L5.59304 7.7455ZM1.67094 11.6693C1.67094 11.2081 1.2971 10.8343 0.835938 10.8343C0.37478 10.8343 0.000937521 11.2081 0.000937521 11.6693H0.835938H1.67094ZM16.6709 11.6693C16.6709 11.2081 16.2971 10.8343 15.8359 10.8343C15.3748 10.8343 15.0009 11.2081 15.0009 11.6693H15.8359H16.6709ZM14.4709 15.5635L14.0918 14.8195H14.0918L14.4709 15.5635ZM15.5635 14.4709L16.3074 14.85V14.85L15.5635 14.4709ZM1.10842 14.4709L0.364431 14.85V14.85L1.10842 14.4709ZM2.20096 15.5635L1.82188 16.3074H1.82188L2.20096 15.5635ZM8.33594 0.835938L7.50094 0.835938L7.50094 10.0026L8.33594 10.0026H9.17094L9.17094 0.835937L8.33594 0.835938ZM11.6693 8.33594L11.0788 7.7455L8.33476 10.4896L8.92519 11.08L9.51563 11.6704L12.2597 8.92637L11.6693 8.33594ZM7.74668 11.08L8.33712 10.4896L5.59304 7.7455L5.0026 8.33594L4.41217 8.92637L7.15625 11.6704L7.74668 11.08ZM8.92519 11.08L8.33476 10.4896C8.33383 10.4905 8.33436 10.4898 8.33573 10.4893C8.33654 10.4889 8.33658 10.4891 8.33594 10.4891C8.33529 10.4891 8.33533 10.4889 8.33614 10.4893C8.33751 10.4898 8.33804 10.4905 8.33712 10.4896L7.74668 11.08L7.15625 11.6704C7.80777 12.322 8.8641 12.322 9.51563 11.6704L8.92519 11.08ZM0.835938 11.6693H0.000937521V11.8359H0.835938H1.67094V11.6693H0.835938ZM4.83594 15.8359V16.6709H11.8359V15.8359V15.0009H4.83594V15.8359ZM15.8359 11.8359H16.6709V11.6693H15.8359H15.0009V11.8359H15.8359ZM11.8359 15.8359V16.6709C12.5222 16.6709 13.0872 16.6716 13.5459 16.6341C14.0144 16.5958 14.4453 16.5137 14.85 16.3074L14.4709 15.5635L14.0918 14.8195C13.9618 14.8857 13.7752 14.9398 13.4099 14.9696C13.0349 15.0003 12.5498 15.0009 11.8359 15.0009V15.8359ZM15.8359 11.8359H15.0009C15.0009 12.5498 15.0003 13.0349 14.9697 13.4099C14.9398 13.7752 14.8857 13.9618 14.8195 14.0918L15.5635 14.4709L16.3074 14.85C16.5137 14.4453 16.5958 14.0144 16.6341 13.5459C16.6716 13.0872 16.6709 12.5222 16.6709 11.8359H15.8359ZM14.4709 15.5635L14.85 16.3074C15.4775 15.9877 15.9877 15.4775 16.3074 14.85L15.5635 14.4709L14.8195 14.0918C14.6598 14.4051 14.4051 14.6598 14.0918 14.8195L14.4709 15.5635ZM0.835938 11.8359H0.000937521C0.000937521 12.5222 0.000288129 13.0872 0.0377711 13.5459C0.0760505 14.0144 0.158215 14.4453 0.364431 14.85L1.10842 14.4709L1.85241 14.0918C1.78614 13.9618 1.73207 13.7752 1.70222 13.4099C1.67159 13.0349 1.67094 12.5498 1.67094 11.8359H0.835938ZM4.83594 15.8359V15.0009C4.12209 15.0009 3.63693 15.0003 3.26194 14.9696C2.8967 14.9398 2.7101 14.8857 2.58004 14.8195L2.20096 15.5635L1.82188 16.3074C2.2266 16.5137 2.65743 16.5958 3.12595 16.6341C3.58472 16.6716 4.14965 16.6709 4.83594 16.6709V15.8359ZM1.10842 14.4709L0.364431 14.85C0.684169 15.4775 1.19436 15.9877 1.82188 16.3074L2.20096 15.5635L2.58004 14.8195C2.26675 14.6598 2.01204 14.4051 1.85241 14.0918L1.10842 14.4709Z"
        fill="#F9F9F9"
    />
</svg>
    ;

interface InvozioAppTourProps {
    onStartTour?: () => void;
}

export const InvozioAppTour: React.FC<InvozioAppTourProps> = ({
    onStartTour,
}) => {
    const { t } = useTranslation();
    const lang = new URLSearchParams(window.location.search).get('lang');
    const { userOnboardingData } = useSelector((state: any) => state.auth);
    const { isFirstTimeUser } = useOnboardingStatus(userOnboardingData);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [skipped, setSkipped] = useState(false);
    const dispatch = useAppDispatch();

    function handleDownloadGuide() {

        const isSwedish = lang === 'en-us'
            ? `https://invozioprod.blob.core.windows.net/files/Manual_Invozio__ENG_2026.pdf`
            : `https://invozioprod.blob.core.windows.net/files/Manual_Invozio__SV_2026.pdf`

        window.open(isSwedish, '_blank');
    }
    async function handleClose() {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await dispatch(updateUserOnboardingService({ actionType: 'isNewUserSkipped', value: true })).unwrap();
            setSkipped(true);
            try { dispatch(getUserOnboarding()); } catch (e) { /* ignore */ }
        } catch (err) {
            console.error('Failed to skip onboarding', err);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="invozio-app-tour-container ">
            <div className="app-tour-header">
                <div className="new-experience-label">
                    {starIcon}
                    <span className="label-text">{t('NEW_EXPERIENCE')}</span>
                </div>
                <button className="close-button" onClick={handleClose} aria-label="Close">
                    {closeIcon}
                </button>
            </div>

            <h2 className="tour-title">
                {isFirstTimeUser ? t('WELCOME_TO_YOUR_FIRST_STEP') : t('WELCOME_TO_YOUR_UPDATED_WORKSPACE')}
            </h2>

            <p className="tour-description">
                {isFirstTimeUser ? t('TOUR_DESCRIPTION_FOR_NEW_USERS') : t('TOUR_DESCRIPTION_FOR_EXISTING_USERS')}
            </p>

            <div className="tour-actions">
                <button
                    className="start-tour-button"
                    onClick={onStartTour}
                >
                    {playIcon}
                    <span>{t('START_APP_TOUR')}</span>
                </button>

                <button
                    className="download-guide-button"
                    onClick={handleDownloadGuide}
                >
                    <span>{t('DOWNLOAD_USER_GUIDE')}</span>
                    {downloadIcon}
                </button>
            </div>
        </div>
    );
};

export default InvozioAppTour;